import React from 'react'
import { Card, Loader } from 'semantic-ui-react'

export default () => (
  <Card centered style={{ minHeight: '200px' }}>
    <Loader active />
  </Card>
)
